var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_8529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.0909C15.5207 19.0909 19.5909 15.0208 19.5909 10C19.5909 4.97926 15.5207 0.909119 10.5 0.909119C5.4792 0.909119 1.40906 4.97926 1.40906 10C1.40906 15.0208 5.4792 19.0909 10.5 19.0909Z",
    stroke: "url(#paint0_linear_408_8529)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85449 7.27275C8.06822 6.66518 8.49009 6.15285 9.04536 5.82651C9.60064 5.50017 10.2535 5.38088 10.8883 5.48976C11.5231 5.59865 12.0989 5.92868 12.5137 6.42141C12.9284 6.91414 13.1555 7.53777 13.1545 8.18184C13.1545 10 10.4272 10.9091 10.4272 10.9091",
    stroke: "url(#paint1_linear_408_8529)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5455H10.51",
    stroke: "url(#paint2_linear_408_8529)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_408_8529",
    x1: 1.40906,
    y1: 10,
    x2: 19.5909,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_408_8529",
    x1: 7.85449,
    y1: 8.17981,
    x2: 13.1545,
    y2: 8.17981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_408_8529",
    x1: 10.5,
    y1: 15.0455,
    x2: 10.51,
    y2: 15.0455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_8529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupportIcon);
export default __webpack_public_path__ + "static/media/ContactSupportIcon.ce440bdbeef4925154fb0274b0da29b0.svg";
export { ForwardRef as ReactComponent };